import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import '../index.scss';

import iconDelete from '../../../assets/images/icon_delete_red.svg';
import iconAdd from '../../../assets/images/icon_add_blue.svg';

const TemplateBotFunctionalitiesInput = (props) => {
  const { templateBotData, functionalities, addInputErrorClass } = props;

  useEffect(() => {
    const { functionalities: formFunc } = templateBotData;
    if (!_.isEqual(_.sortBy(formFunc), _.sortBy(functionalities))) {
      const { setFunctionalities } = props;
      setFunctionalities(templateBotData.functionalities);
    }
  }, [templateBotData.functionalities]);

  useEffect(() => {
    if (functionalities.length === 0) {
      const { setFunctionalities } = props;
      const newFunctionalities = [...functionalities];
      newFunctionalities.push('');
      setFunctionalities(newFunctionalities);
    }
  }, [functionalities]);

  const onClickAddFunctionalityInput = (event) => {
    event.preventDefault();
    const canAdd = functionalities.indexOf('');

    if (canAdd === -1) {
      const { setFunctionalities } = props;
      const newFunctionalities = [...functionalities];
      newFunctionalities.push('');
      setFunctionalities(newFunctionalities);
    }
  };

  const onClickRemoveFunctionalityInput = (event, index) => {
    event.preventDefault();
    const { setFunctionalities } = props;
    const newFunctionalities = [...functionalities];
    newFunctionalities.splice(index, 1);
    setFunctionalities(newFunctionalities);
  };

  const onChangeFunctionalityInput = (event, index) => {
    event.preventDefault();
    const {
      isFunctionalitiesTouched,
      setIsFunctionalitiesTouched,
      setFunctionalities,
    } = props;
    const newValue = event.target.value;
    const newFunctionalities = [...functionalities];
    newFunctionalities[index] = newValue;
    setFunctionalities(newFunctionalities);

    if (!isFunctionalitiesTouched) {
      setIsFunctionalitiesTouched(true);
    }
  };

  const renderRemoveFunctionalityButton = (index) => {
    if (functionalities.length === 1) {
      return false;
    }
    return (
      <img
        src={iconDelete}
        alt="Delete"
        onClick={(event) => onClickRemoveFunctionalityInput(event, index)}
      />
    );
  };

  const renderAddFunctionalityButton = () => {
    if (functionalities.length >= 4) {
      return false;
    }
    return (
      <img src={iconAdd} alt="Add" onClick={onClickAddFunctionalityInput} />
    );
  };

  const renderFunctionalitiesInputs = () => {
    if (functionalities.length < 1) {
      return false;
    }

    return functionalities.map((functionality, index) => {
      return (
        <div
          key={['functionality', index].join('_')}
          className={`template-bot-modal-functionalities-element ${addInputErrorClass(
            'functionalities'
          )}`}
        >
          <input
            type="text"
            value={functionality}
            maxLength={100}
            onChange={(event) => onChangeFunctionalityInput(event, index)}
          />
          {renderRemoveFunctionalityButton(index)}
        </div>
      );
    });
  };

  return (
    <div className="template-bot-modal-functionalities-container">
      <label>Listagem de Funcionalidades*</label>
      {renderFunctionalitiesInputs()}
      <div className="template-bot-modal-functionalities-add">
        <label>Adicionar funcionalidade</label>
        {renderAddFunctionalityButton()}
      </div>
    </div>
  );
};

export default TemplateBotFunctionalitiesInput;
